import { clsx } from 'clsx';
import * as styles from './styles.css';
import { TG, VK, YT } from 'shared/constants/links';
import { useDeviceType } from '@cian/ui-kit';
import { CianLogoSign } from '@cian/ui-kit-design-tokens/logo';

export const Footer: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <CianLogoSign colorType="onBright" size={24} />
      <div className={styles['socials']}>
        <a className={clsx(styles['vk'], styles['social'])} target="_blank" href={VK} rel="noreferrer" />
        <a className={clsx(styles['yt'], styles['social'])} target="_blank" href={YT} rel="noreferrer" />
        <a className={clsx(styles['tg'], styles['social'])} target="_blank" href={TG} rel="noreferrer" />
      </div>
    </div>
  );
};
